import { clsx } from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

import Icon, { type IconName } from '@components/Icon/Icon';

import classes from './Button.module.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
	children: ReactNode;
	fullWidth?: boolean;
	isLoading?: boolean;
	primary?: boolean;
	secondary?: boolean;
	uppercase?: boolean;
	disabled?: boolean;
	icon?: IconName;
	iconColor?: string;
	className?: string;
	style?: React.CSSProperties;
}

export const Button: React.FC<Props> = ({
	children,
	fullWidth = false,
	isLoading = false,
	primary = false,
	secondary = false,
	uppercase = false,
	disabled = false,
	icon,
	iconColor = 'var(--background)',
	className,
	style,
	...props
}: React.PropsWithChildren<Props>) => {
	return (
		<button
			className={clsx(
				classes['button'],
				fullWidth && classes['fullWidth'],
				isLoading && classes['loading'],
				uppercase && classes['uppercase'],
				primary && classes['primary'],
				secondary && classes['secondary'],
				className,
			)}
			disabled={disabled || isLoading}
			style={style}
			{...props}
		>
			{icon && (
				<span className={classes['icon']}>
					<Icon name={icon} size={24} color={iconColor} />
				</span>
			)}
			{isLoading ? <span className={classes['spinner']} /> : children}
		</button>
	);
};
